import { LineSectionInterface, DbdInterface } from '../dbds/types';
import { EmployeeInterface } from '../employees/types';
import { TripBaseInterface } from '../trips/types';

/*
 * Action Types
 */
export enum FleetTypes {
  LIST_CARS_REQUEST = '@fleet/LIST_CARS_REQUEST',
  LIST_CARS_SUCCESS = '@fleet/LIST_CARS_SUCCESS',
  LIST_CARS_FAILURE = '@fleet/LIST_CARS_FAILURE',

  GET_CAR_REQUEST = '@fleet/GET_CAR_REQUEST',
  GET_CAR_SUCCESS = '@fleet/GET_CAR_SUCCESS',
  GET_CAR_FAILURE = '@fleet/GET_CAR_FAILURE',

  FILTER_CARS_REQUEST = '@fleet/FILTER_CARS_REQUEST',
  FILTER_CARS_SUCCESS = '@fleet/FILTER_CARS_SUCCESS',
  FILTER_CARS_FAILURE = '@fleet/FILTER_CARS_FAILURE',

  FILTER_MONITORING_CARS_REQUEST = '@fleet/FILTER_MONITORING_CARS_REQUEST',
  FILTER_MONITORING_CARS_SUCCESS = '@fleet/FILTER_MONITORING_CARS_SUCCESS',
  FILTER_MONITORING_CARS_FAILURE = '@fleet/FILTER_MONITORING_CARS_FAILURE',

  LIST_CARS_REPORT_REQUEST = '@fleet/LIST_CARS_REPORT_REQUEST',
  LIST_CARS_REPORT_SUCCESS = '@fleet/LIST_CARS_REPORT_SUCCESS',
  LIST_CARS_REPORT_FAILURE = '@fleet/LIST_CARS_REPORT_FAILURE',

  LIST_ALL_CARS_REQUEST = '@fleet/LIST_ALL_CARS_REQUEST',
  LIST_ALL_CARS_SUCCESS = '@fleet/LIST_ALL_CARS_SUCCESS',
  LIST_ALL_CARS_FAILURE = '@fleet/LIST_ALL_CARS_FAILURE',

  LIST_CARS_QUANTITY_REPORT_REQUEST = '@fleet/LIST_CARS_QUANTITY_REPORT_REQUEST',
  LIST_CARS_QUANTITY_REPORT_SUCCESS = '@fleet/LIST_CARS_QUANTITY_REPORT_SUCCESS',
  LIST_CARS_QUANTITY_REPORT_FAILURE = '@fleet/LIST_CARS_QUANTITY_REPORT_FAILURE',

  CREATE_CAR_REQUEST = '@fleet/CREATE_CAR_REQUEST',
  CREATE_CAR_SUCCESS = '@fleet/CREATE_CAR_SUCCESS',
  CREATE_CAR_FAILURE = '@fleet/CREATE_CAR_FAILURE',
  CREATE_CARS_BATCH_REQUEST = '@fleet/CREATE_CARS_BATCH_REQUEST',

  UPDATE_CAR_REQUEST = '@fleet/UPDATE_CAR_REQUEST',
  UPDATE_CAR_SUCCESS = '@fleet/UPDATE_CAR_SUCCESS',
  UPDATE_CAR_FAILURE = '@fleet/UPDATE_CAR_FAILURE',

  DELETE_CAR_REQUEST = '@fleet/DELETE_CAR_REQUEST',
  DELETE_CAR_SUCCESS = '@fleet/DELETE_CAR_SUCCESS',
  DELETE_CAR_FAILURE = '@fleet/DELETE_CAR_FAILURE',

  GET_CAR_SETTINGS_REQUEST = '@fleet/GET_CAR_SETTINGS_REQUEST',
  GET_CAR_SETTINGS_SUCCESS = '@fleet/GET_CAR_SETTINGS_SUCCESS',
  GET_CAR_SETTINGS_FAILURE = '@fleet/GET_CAR_SETTINGS_FAILURE',

  UPDATE_CAR_SETTINGS_REQUEST = '@fleet/UPDATE_CAR_SETTINGS_REQUEST',
  UPDATE_CAR_SETTINGS_SUCCESS = '@fleet/UPDATE_CAR_SETTINGS_SUCCESS',
  UPDATE_CAR_SETTINGS_FAILURE = '@fleet/UPDATE_CAR_SETTINGS_FAILURE',
}

/*
 * Data types
 */
export interface TripInterface extends TripBaseInterface {
  TransportEmployee: EmployeeInterface;
  LineSection: LineSectionInterface;
  Dbd: DbdInterface;
}

export interface CarInterface {
  id: string;
  license: string;
  prefix: string;
  model: string;
  sitCapacity: number;
  footCapacity: number;
  hasPassenger: boolean;
  hasVehicle: boolean;
  ticketer: boolean;
  accessible: boolean;
  airConditioned: boolean;
  age: number;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
  Trip?: TripInterface;
  Trips?: TripInterface[];
  vehicleCapacity: number;
  wifi: boolean;
  bathroom: boolean;
  gateType?: number;
  seatmapId?: string | null;
}

export interface CarReportInterface {
  [key: string]: {
    valuePerKm: number;
    totalValue?: number;
    ipk: number;
    ipke: number;
    kvd: number;
    pvd: number;
    kpis: {
      ipk: number;
      ipke: number;
      valuePerKm: number;
      kvd: number;
      pvd: number;
      km: number;
      idleKm: number;
      trips: number;
    };
    benefits: object;
    benefitsCount: object;
  };
}
export interface CarSettingsInterface {
  id: string;
  params: {
    motorcycle: number;
    car: number;
    wheelbarrow: number;
    trailer: number;
    lightTruck: number;
    mediumTruck: number;
    heavyTruck: number;
  };
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
}

/*
 * State type
 */
export interface FleetState {
  readonly carsList: CarInterface[];
  readonly carsListFull: CarInterface[];
  readonly allCarsList: CarInterface[];
  readonly filterCarsList: CarInterface[];
  readonly carData: CarInterface;
  readonly reports: CarReportInterface;
  readonly reportsQuantity: CarReportInterface;
  readonly carSettingsData: CarSettingsInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
